module.exports = "<div class=\"icon\">\n  <i *ngIf=\"type == 'warning'\" class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n</div>\n<div class=\"message\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/alert/alert.component.html
// module id = 486
// module chunks = 1